module.exports = __webpack_public_path__ + "img/tjk.de135042.svg";